// checkUserPermission.tsx

import Personas from "../../models/componentModels/Personas";

interface Props {
  component: string;
  isLoggedInUser: boolean;
  OrganizationInformation?: any;

  userPersonaLoggedin: string;
  cellValues: {
    row: {
      roles: { name: string }[];
    };
  };
}

export const isEditButtonDisabled = (props: Props) => {
  if (!props) {
    return null;
  }

  const { component, isLoggedInUser, userPersonaLoggedin, cellValues } = props;
  if (isLoggedInUser) {
    return false;
  }
  if (component === "tenantUserPage") {
    if (userPersonaLoggedin === Personas.HoneywellAdmin) {
      if (
        cellValues.row.roles.some(
          (x: { name: string }) => x.name === Personas.TenantAdmin
        )
      ) {
        return true;
      }
    } else if (userPersonaLoggedin === Personas.TenantAdmin) {
      return true;
    } else {
      return false;
    }
  } else if (props?.component === "organizationUserList") {
    return props?.OrganizationInformation?.permissionSet
      ?.can_update_organisation_user;
  } else {
    return false;
  }
};
